import { API } from '../config/apiBase';

const VAPID_PUBLIC_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY || '';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) outputArray[i] = rawData.charCodeAt(i);
  return outputArray;
}

export async function registerPushNotifications(token) {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    console.log('Push not supported');
    return { supported: false };
  }

  try {
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') return { supported: true, permission: 'denied' };

    const reg = await navigator.serviceWorker.register('/sw-push.js');
    await navigator.serviceWorker.ready;

    let subscription = await reg.pushManager.getSubscription();
    if (!subscription) {
      // Chave VAPID: usa env de build se houver, senao busca do backend em runtime.
      let key = VAPID_PUBLIC_KEY;
      if (!key) {
        try {
          const r = await fetch(`${API}/push/vapid-public-key`);
          if (r.ok) { const d = await r.json(); key = d.public_key || ''; }
        } catch (_) { /* ignore */ }
      }
      if (!key) return { supported: true, error: 'VAPID key missing' };
      subscription = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(key),
      });
    }

    // Send subscription to backend
    await fetch(`${API}/push/subscribe`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
      body: JSON.stringify({ subscription: subscription.toJSON() }),
    });

    return { supported: true, permission: 'granted', subscribed: true };
  } catch (err) {
    console.error('Push registration failed:', err);
    return { supported: true, error: err.message };
  }
}

export async function unsubscribePush(token) {
  try {
    const reg = await navigator.serviceWorker.getRegistration('/sw-push.js');
    if (reg) {
      const sub = await reg.pushManager.getSubscription();
      if (sub) {
        const endpoint = sub.endpoint;
        await sub.unsubscribe();
        await fetch(`${API}/push/unsubscribe`, {
          method: 'DELETE',
          headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
          body: JSON.stringify({ endpoint }),
        });
      }
    }
    return true;
  } catch (err) {
    console.error('Unsubscribe failed:', err);
    return false;
  }
}

export function isPushSupported() {
  return 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
}

export function getPushPermission() {
  if (!('Notification' in window)) return 'unsupported';
  return Notification.permission;
}
